import React from 'react';
import {LoadingState, TOGGLE_ACTIVE_EVENT} from './state';
import {Loading} from '../components/loading/index';
//import {mapState, PADDING_SPACE_EVENT} from '../../state/map';
import { connect } from 'react-redux';

class LoadingCont extends React.Component {
	constructor(props) {
		super();

		this.state = {
			active: LoadingState.getActive(),
			name: '',
			data: [],
		//	padding: mapState.getPadding()
		}

	/*	var arrIndGroups = indicatorsState.getGroups();

		for (var i = arrIndGroups.length - 1; i >= 0; i--) {

			fieldMap[arrIndGroups[i].id] = arrIndGroups[i].name;
		}*/
	}
	componentDidMount() {

		LoadingState.on(TOGGLE_ACTIVE_EVENT, () => {

			this.setState({active: LoadingState.getActive()});
		});

	/*	mapState.on(PADDING_SPACE_EVENT, ()=>{

			this.setState({padding: mapState.getPadding()});
		});*/
	}
	render() {

		if(this.state.active){
			return (<div>
				<Loading right={(this.props.padding[1] + 25)} />
			</div>);	
		} else {
			return null;
		}

	}
}

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickItem: () => {
      
    }
  }
}

const mapStateToPropsRes = (state) => {

  return {
    padding: state.map.padding
  }
}

const Comp = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(LoadingCont);

export default Comp;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/loading/container.js